import { put, call, takeLatest } from 'redux-saga/effects';

import AuthUtil from '../../AuthUtil';
import { AUDIT } from '../../../components/global/Server/endpoints';
import { showErrorMessage } from '../../actions/global';
import { SERVER_FAILED_ERROR_MESSAGE } from '../../../pages/Dashboard/constants';
import {
    LIST_READING_SESSION_AUDIT,
    LIST_WEEKLY_REPORT_AUDIT,
} from '../../constants/audit';
import {
    storeReadingSessionAudit,
    storeWeeklyReportAudit,
} from '../../actions/audit';

function* listReadingSessionAuditSaga(action) {
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(AUDIT.LIST_READING_SESSION_AUDIT, action.data)
        );
        if (response.status === 200 && response.data.success) {
            yield put(storeReadingSessionAudit(response.data.logs));
        } else {
            yield put(showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE));
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* listWeeklyReportAuditSaga(action) {
    try {
        const response = yield call(() =>
            AuthUtil.postRequest(AUDIT.LIST_WEEKLY_REPORT_AUDIT, action.data)
        );
        if (response.status === 200 && response.data.success) {
            yield put(storeWeeklyReportAudit(response.data.logs));
        } else {
            yield put(showErrorMessage(response.data?.message || SERVER_FAILED_ERROR_MESSAGE));
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

export default function* auditSagas() {
    yield takeLatest(LIST_READING_SESSION_AUDIT, listReadingSessionAuditSaga);
    yield takeLatest(LIST_WEEKLY_REPORT_AUDIT, listWeeklyReportAuditSaga);
}
